import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { DropZone, DropZoneFile } from '../file-upload/drop-zone/DropZone'

interface IFormDropZoneUploadProps {
  name:string
  field: { name: string; value: any; onChange: () => void }
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  disabled?: boolean
  maxFiles?: number
  handlerOnDrop?: (val: DropZoneFile[]) => void
}

export const FormDropZoneUpload: React.FC<IFormDropZoneUploadProps> = (props) => {
   
 
  // const [uploaded, setUploaded] = useState<DropZoneFile[]>([])
  const handlerOnDrop = (files: DropZoneFile[]) => {
    //setFiles((a) => [...a, ...files])
    
    // console.log( 'handlerOnDrop',[...props.field.value, ...files])
    //setUploaded(dropFiles)
    //props.form.setFieldValue(props.field.name,props.field.value)
    //props.handlerOnDrop?.(files)
    console.log('sould have',props.field.value)
    props.form.setFieldValue(props.field.name,[...props.field.value,...files])

  }
  const handlerOnDelete = (values: DropZoneFile[]) => {    
    props.form.setFieldValue(props.field.name, values)
  }

  // if(uploaded.length>0){s
  //   setFiles([ ...files,...uploaded])
  //   setUploaded([])    
  // }

  
  
  return (
    <>   
      <DropZone
        maxFiles={props.maxFiles}
        handlerOnDrop={handlerOnDrop}
        handlerOnDelete={handlerOnDelete}
        fileState={props.field.value}
      />
    </>
  )
}

